import React, { lazy, Suspense, useCallback, useEffect } from "react";
import ReactDOM from "react-dom";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import { ConnectedRouter } from "connected-react-router";
import { Provider, useDispatch, useSelector } from "react-redux";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import configureStore, { history } from "../../redux/store";
import AppContextProvider from "@jumbo/components/contextProvider/AppContextProvider";
import { Redirect, Route, Switch } from "react-router";
import Router from "@codeArt/electron/renderer/router";
import { Principal } from "../auth";
import { runtime, Storage } from "../common";
import { AliveScope as KeepAliveProvider, useAliveController } from 'react-activation';
import "../assets/style";
import { invalid } from "@codeArt/utils/common";
import { get as getWindowInfo } from "@codeArt/electron/renderer/window";
import ContentLoader from "@jumbo/components/ContentLoader";
import { init as _initExtension } from "@codeArt/extension/index";
import PageLoader from "@jumbo/components/PageComponents/PageLoader";
import { activate } from "@codeArt/extension";
import { off, on } from "@codeArt/electron/renderer/ipc";
import ErrorCatch from "./error_catch";
import App from "./app";
import { fetchError } from "redux/actions";

let _ = require("lodash");

// let keepAliveProvider = null;

let keepDrop = null;
let keepClear = null;
let default_request_config = null;

export function get_request_config(){  //获得默认的请求配置
  return default_request_config;
}

export function unKeepCache(keepId) {
  if (keepId) keepDrop(keepId);
  else keepClear();
}

const store = configureStore();

//框架内部自带的子应用
const _apps = [
  {path: "/extension/admin/setting", component: lazy(() => import("@codeArt/apps/page/extension/admin/setting")), authable: true},
];

const Index = ({ project, apps, components, portal, deactivate,request }) => {

  Storage.version = project.version;
  const { drop, clear } = useAliveController()
  keepDrop = drop;
  keepClear = clear;
  default_request_config = request;

  useEffect(() => {

    addListenMainError();

    return () => {
      removeListenMainError();
      if (deactivate) deactivate();  //这里其实有个问题,deactivate是异步的，有可能没有执行完，程序就完全销毁了，不过一般来讲，程序销毁了，所有资源也释放了，因此问题不大
    }
  }, []);

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <AppContextProvider project={project}>
          {/* 放在这里才不会影响路由 */}
          <KeepAliveProvider>
            <Suspense fallback={<PageLoader />}>
              <Router>
                <Switch>
                  {renderApps([..._apps,...apps], portal)}
                </Switch>
                {renderDefaultLogined(portal)}
              </Router>
            </Suspense>
            <ContentLoader />
            {components.map((c, index) => <React.Fragment key={`global-component-${index}`}>{c}</React.Fragment>)}
          </KeepAliveProvider>
        </AppContextProvider>
      </ConnectedRouter>
    </Provider>
  );
};

function renderApps(apps, portal) {
  return apps.map(({ path, component, authable }, index) => {
    if (authable)
      return (
        <RestrictedRoute
          key={`route-${index}`}
          path={path}
          login={portal.login}
          component={component}
        />
      );
    return <Route key={`route-${index}`} path={path} component={component} />;
  });
}

function renderDefaultLogined(portal) {  //当登录受，默认跳转的页面
  if (portal.logined) {
    if (window.location.pathname === "/")
      return (
        <Redirect
          to={{
            pathname: portal.logined
          }}
        />
      );
  }
}

const requireUpdate = (function () {  //最新版本号

  function getCacheVersion() {
    return localStorage.getItem("app_version");
  }

  function setCacheVersion(newVer) {
    return localStorage.setItem("app_version", newVer);
  }

  function getNewVersionUrl(newVer) {
    let paras = new URLSearchParams(window.location.search);
    paras.set("_app_ver", newVer);
    let query = paras.toString();
    return `${window.location.pathname}?${query}`;
  }

  function requireUpdate(latestVersion) {
    let oldVer = getCacheVersion();
    let newVer = latestVersion;

    if (invalid(oldVer)) {
      //没有记录过版本号，说明是用户第一次访问，不需要更新
      setCacheVersion(newVer); //更新版本号
      return false;
    }


    if (oldVer !== latestVersion) {
      setCacheVersion(newVer); //更新版本号

      let url = getNewVersionUrl(newVer);
      window.location.replace(url);
      console.log("版本已更新");
      return true;
    }
  }

  return requireUpdate;
})();

export default function Root(config) {
  if (requireUpdate(config.project?.version)) return;
  // consoleSetting(config.console || {});
  tryInitElectron(() => {
    initExtension((deactivate) => {
      ReactDOM.render(
        <ErrorCatch>
          <Index {...config} deactivate={deactivate} />
        </ErrorCatch>,
        document.getElementById("root")
      );
    });
  });
}

const tryInitElectron = (action) => {
  if (!runtime.electron) return action();
  getWindowInfo().then(({ id }) => {
    runtime.electron = { winId: id };
    action();
  });
}

const initExtension = (action) => {
  _initExtension().then(() => {
    activate("onRoot").then((deactivate) => { //激活系统内置事件onRoot，表示程序启动时
      action(deactivate);
    });
  });
}

const RestrictedRoute = ({ login, component: Component, ...rest }) => {
  const { authUser, referrer } = useSelector(({ auth }) => auth);
  return (
    <Route
      {...rest}
      render={props =>
        authUser || Principal.isLogined() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: login,
              state: { referrer: referrer ? props.location.pathname : null }
            }}
          />
        )}
    />
  );
};


function consoleSetting({ ignore }) {//控制台配置
  // if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
  //   const errorFn = global.console.error;
  //   const warnFn = global.console.warn;

  //   const contains = (target, pattern) => {
  //     let value = 0;
  //     pattern.forEach(word => (value = value + target.includes(word)));
  //     return value === 1;
  //   };

  //   ignore = ignore||{};

  //   const ignoreListError = [
  //     'The `fade` color utility was renamed to `alpha` to better describe its functionality.',
  //     'the createMuiTheme function was renamed to createTheme',
  //     ...(ignore.error || [])
  //   ];

  //   const ignoreListWarn = ['The `theme.typography.round` helper is deprecated.',
  //   ...(ignore.warn || [])
  //   ];

  //   global.console.error = msg => {
  //     if (!(typeof msg === 'string' && msg.indexOf('Material-UI') !== -1 && contains(msg, ignoreListError))) {
  //       errorFn(msg);
  //     }
  //   };

  //   global.console.warn = msg => {
  //     if (!(typeof msg === 'string' && msg.indexOf('Material-UI') !== -1 && contains(msg, ignoreListWarn))) {
  //       warnFn(msg);
  //     }
  //   };
  // }
}

//侦听主进程的error
const addListenMainError = () => {
  if (runtime.electron) on("error.root", ({ arg }) => {
    const dispatch = App.dispatch();
    dispatch(fetchError(arg.message));
  });
}

const removeListenMainError = () => {
  if (runtime.electron) off("error.root");
}
